import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../hooks/useSession';

interface AuthGuardProps {
  /** Si true, redirige a /login si NO hay sesión. Si false, redirige a / si SÍ hay sesión. */
  requireAuth?: boolean;
}

/**
 * Protege rutas. Uso:
 * <AuthGuard requireAuth><ProtectedContent /></AuthGuard>
 * <AuthGuard requireAuth={false}><LoginPage /></AuthGuard>
 */
export function AuthGuard({ children, requireAuth = true }: PropsWithChildren<AuthGuardProps>) {
  const { session, isLoading } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted animate-pulse text-sm">···</div>
      </div>
    );
  }

  if (requireAuth && !session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!requireAuth && session) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
